import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {
  Table,
  TableHeader,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
} from "../../../components/Table";
import { InfoBox } from "../../../components/InfoBox";
import { spacing } from "@styling/sizing";

const ErrorsContainer = styled.div`
  margin-top: ${spacing.x3}px;
`;

const ErrorsTitle = styled.div`
  margin-bottom: ${spacing.x2}px;
  font-weight: 600;
`;

const ErrorValueCell = styled.div`
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

interface Error {
  row: number;
  field: string;
  message: string;
  value: string;
}

interface ErrorsTableProps {
  errors: Error[];
}

export const ErrorsTable = ({ errors }: ErrorsTableProps) => {
  const { t } = useTranslation();

  if (errors.length === 0) {
    return null;
  }

  const summary =
    errors.length === 1
      ? t("productImport.errorsFoundOne")
      : t("productImport.errorsFoundMany", { count: errors.length });

  return (
    <>
      <InfoBox variant="error">{summary}</InfoBox>
      <ErrorsContainer>
        <ErrorsTitle>{t("productImport.errorsTitle", { count: errors.length })}</ErrorsTitle>
        <Table>
          <TableHeader>
            <tr>
              <TableHeaderCell align="right">{t("productImport.tableRow")}</TableHeaderCell>
              <TableHeaderCell>{t("productImport.tableField")}</TableHeaderCell>
              <TableHeaderCell>{t("productImport.tableMessage")}</TableHeaderCell>
              <TableHeaderCell>{t("productImport.tableValue")}</TableHeaderCell>
            </tr>
          </TableHeader>
          <TableBody>
            {errors.map((error, index) => (
              <TableRow key={index}>
                <TableCell align="right">{error.row}</TableCell>
                <TableCell>{error.field}</TableCell>
                <TableCell>{error.message}</TableCell>
                <TableCell>
                  <ErrorValueCell title={error.value}>{error.value}</ErrorValueCell>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ErrorsContainer>
    </>
  );
};
